import { Route } from '@/app/router'

const Client = () => import('./index.vue')

export default new Route('/clients/:id', Client).as('Dashboard:Client').permissions(['VIEW_CLIENT'])
